import script from "./a-side.vue?vue&type=script&setup=true&lang=js"
export * from "./a-side.vue?vue&type=script&setup=true&lang=js"

import "./a-side.vue?vue&type=style&index=0&id=40ad863f&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ad863f"]])

export default __exports__